<template>
  <div class="app">
    <AddTable/>
  </div>
</template>

<script>
import AddTable from '@/components/AddTable.vue'

export default {
  name: 'add',
  components: {
    AddTable
  }
}
</script>
